import {
  assertVegaLiteJsonTree,
  type JsonObject,
  type JsonValue,
  validateVegaLiteJsonTree,
} from './vega-lite-json-tree';

export {
  isJsonPrimitive,
  type JsonObject,
  type JsonPrimitive,
  type JsonValue,
} from './vega-lite-json-tree';

export function isJsonValue(value: unknown): value is JsonValue {
  return validateVegaLiteJsonTree(value).status === 'valid';
}

export function isJsonObject(value: unknown): value is JsonObject {
  return typeof value === 'object' && value !== null && !Array.isArray(value) && isJsonValue(value);
}

export function cloneJsonObject(value: JsonObject): JsonObject {
  assertVegaLiteJsonTree(value);
  return JSON.parse(JSON.stringify(value)) as JsonObject;
}

export function escapeJsonPointerSegment(segment: string): string {
  return segment.replace(/~/g, '~0').replace(/\//g, '~1');
}

export function utf8ByteLength(value: string): number {
  let bytes = 0;

  for (const character of value) {
    const code = character.codePointAt(0) ?? 0;

    if (code <= 0x7f) {
      bytes += 1;
    } else if (code <= 0x7ff) {
      bytes += 2;
    } else {
      bytes += code <= 0xffff ? 3 : 4;
    }
  }

  return bytes;
}
